export default {
    'en-US': require('./en-US.json')
}


// WEBPACK FOOTER //
// ./src/locales/index.js